import { render, staticRenderFns } from "./NavBarNis.vue?vue&type=template&id=569dd911"
import script from "./NavBarNis.vue?vue&type=script&lang=js"
export * from "./NavBarNis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports